import React, { useState, useEffect, Fragment, useRef } from 'react';
import SimulatorConfiguration, * as SimulatorHelper from '../library/SimulatorHelper';

export default function TMLog() {

    const [innerHtml, setInnerHtml] = useState('');
    const [log, setLog] = useState('');
    const [isLogging, setIsLogging] = useState(true);
    const [simulatorConfiguration, setSimulatorConfiguration] = useState(new SimulatorConfiguration());
    const [ws, setWs] = useState({} as WebSocket);


    const iOSMessage = async (msg: string) => {
        addLogEvent(msg);
    }


    const tableBegin = "<table border='1'>";
    const tableEnd = "</table>";

    const spanRef = useRef<HTMLSpanElement>(null);

    const iOSAnalyzeShot = async (msg: string) => {
        addLogEvent(msg);
    }

    useEffect(()=> {
//        (window as any)["iOSMessage"] = iOSAnalyzeShot;
//        (window as any).webkit.messageHandlers.iOSLoginTM.postMessage(true);
//        (window as any).webkit.messageHandlers.iOSConnectTM.postMessage(true);

    },[])

    useEffect(() => {
        spanRef.current!.innerHTML = innerHtml;
    }, [innerHtml]);

    const logAsync = () => {
        return new Promise<string>((resolve, reject) => {
            setLog(prevValue => {
                resolve(prevValue);
                return prevValue;
            });
        })
    }


    const testConnection = () => {
        (window as any).webkit.messageHandlers.iOSLoginTM.postMessage(true);
/*         setTimeout(()=> {
            (window as any).webkit.messageHandlers.iOSConnectTM.postMessage("ios");
            (window as any).webkit.messageHandlers.iOSConnectTM.postMessage(true);
            testConnection();
        }, 5000);
 */    }

    const addLogEvent = async (text: string) => {
        let oldLog = await logAsync();
        var newLog = oldLog + `<tr><td>${new Date}</td><td>${text}</td></tr>`
        setLog(oldLog => newLog)
        setInnerHtml(oldHtml => tableBegin + newLog + tableEnd);

    }

    const toggleLogging = () => {
        setIsLogging(oldIsLoggine => !isLogging);
    }

    return (
        <>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
            <button onClick={testConnection}>Test Connection</button>
            <button onClick={toggleLogging}>{isLogging.toString()}</button>
            <div>
                <span ref={spanRef} />
            </div>
        </>
    )
}
